<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-I">This story is dedicated to my grandfather</span></p>
<p class="DED"><span class="ePub-I">Henry Mitchell,</span></p>
<p class="DED"><span class="ePub-I">June 2, 1915–July 7, 2014.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a1f821e2